/**
 * 为表格编辑交互统一换算页面坐标，消除长图布局的页面偏移
 * 点击、框选、边框拖动及右键菜单共用此换算，与表格原始图层坐标保持一致。
 */
import type { TransformService } from '@/framework/services/transform';
import type { IPoint, ITableLayer } from '@/version-types';

/**
 * 将浏览器坐标转换为表格所属页面的坐标
 *
 * @param transform - 编辑器坐标变换服务
 * @param point - 浏览器视口中的鼠标位置
 * @param tableLayer - 保留所属页面信息的原始表格图层
 * @returns 扣除长图页面纵向偏移后的坐标
 */
export const getTableFramePoint = (
    transform: Pick<TransformService, 'getScenePoint' | 'calcLayerOffsetTop'>,
    point: IPoint,
    tableLayer: ITableLayer,
): IPoint => {
    const scenePoint = transform.getScenePoint(point);
    return { x: scenePoint.x, y: scenePoint.y - transform.calcLayerOffsetTop(tableLayer) };
};
